const Geo = () => {
    return (
        <div>
            <h1>Geo Chart</h1>
        </div>
           
    )
}

export default Geo;